import React, { Fragment } from "react";
import { withStyles, Button } from "@material-ui/core";
import styles from "../../styles";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import CustomStepper from "./CustomStepper";
class ImportFiles extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <header className={classes.moduleHeader}> Import Files </header>
        <div className={classes.moduleContainer}>
          <div id="mainUploadContainer" className={classes.mainUploadContainer}>
            <div className={classes.uploadHeaderMessage}>
              <p>
                We expect an input in an excel format. A sample template is
                available here.
              </p>
              <Button
                color="primary"
                variant="contained"
                size="small"
                classes={{
                  root: `${classes.actionButton} ${classes.downloadTemplateButton}`,
                }}
              >
                Download Template
              </Button>
            </div>

            <CustomStepper
              steps={[
                { stepAPI: "trailer", stepName: "Trailer Inventory" },
                { stepAPI: "wave", stepName: "Wave Data" },
                { stepAPI: "anchor", stepName: "Anchor Point" },
                { stepAPI: "driver", stepName: "Driver Preference" },
                {
                  stepAPI: "customerSplInst",
                  stepName: "Customer Special Instructions",
                },
                { stepAPI: "freightBill", stepName: "Freight Bills Data" },
                { stepAPI: "inputShipment", stepName: "Input Shipments" },
              ]}
            ></CustomStepper>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile,
  withSnackbar
)(ImportFiles);
